import { http } from "@/lib/http";
export function fetchPopups() {
  return http.get("/api/popups/get_all").then((res) => res.data);
}
export function fetchPopup(id) {
  return http.get(`/api/popups/get/${id}`).then((res) => res.data);
}
export function fetchTopics() {
  return http.get("/api/topics/get_all").then((res) => res.data);
}
export function addPopup(payload) {
  return http.post("/api/popups/add", payload).then((res) => res.data);
}
export function editPopup(id, payload) {
  return http.post(`/api/popups/edit/${id}`, payload).then((res) => res.data);
}
export async function deletePopup(id, imgUrl) {
  const res = await http.delete(`/api/popups/delete/${id}`);
  if (imgUrl) {
    try {
      await http.delete("/api/file/delete", { data: { s3Url: imgUrl } });
    } catch {}
  }
  return res.data;
}
